'use client';

import { useRouter } from 'next/navigation';
import { useTranslation } from 'next-i18next';
import { getPropValue } from '@/utils/utils';
import { routes, rewritesPL, rewritesDefault } from '@/utils/routes';

type RouteKeys = keyof typeof routes;

export const getTranslatedUrl = (
    routeKey: RouteKeys,
    lang: string,
    routeParams: Record<string, string> = {}
): string => {
    const currentRewrites = lang === 'pl' ? rewritesPL : rewritesDefault;

    const found = currentRewrites.find((rewrite) => rewrite.destination === getPropValue(routes, routeKey));

    if (found) {
        let url: string = found.source;
        for (const param of Object.keys(routeParams)) {
            url = url.replace(`:${param}`, routeParams[param]);
        }
        return url;
    }

    let defaultUrl: string = getPropValue(routes, routeKey);
    for (const param of Object.keys(routeParams)) {
        defaultUrl = defaultUrl.replace(`:${param}`, routeParams[param]);
    }
    return defaultUrl;
};

export const useTranslatedRouter = () => {
    const router = useRouter();
    const {
        i18n: { language },
    } = useTranslation();

    const push = (routeKey: RouteKeys, routeParams?: Record<string, string>) => {
        const targetUrl = getTranslatedUrl(routeKey, language, routeParams);
        router.push(targetUrl);
    };

    const replace = (routeKey: RouteKeys, routeParams?: Record<string, string>) => {
        const targetUrl = getTranslatedUrl(routeKey, language, routeParams);
        router.replace(targetUrl);
    };

    return { push, replace };
};
